// extracted by mini-css-extract-plugin
export default {"content":"Information_content__u0DtQ"};